// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosCte from './selecao_todos_cte';
import { Input } from '../../../../../../common/input';

export default function CamposIbsCbs() {
  return (
      <FormSection name="dadosIbsCbs">
        <SelecaoTodosCte nomes={ ['dadosIbsCbs'] } titulo="Dados do IBS / CBS"/>

        <div className="grupo-checkbox">
          <Input name="cstIbsCbs" label="CST" checkbox/>
          <Input name="cClassTrib" label="Cód. Class. Tributária" checkbox/>
          <Input name="indDoacao" label="Ind. Doação" checkbox/>
          <Input name="valorBcIbsCbs" label="BC Comum" checkbox/>
          <Input name="aliquotaIbsUf" label="Alíquota IBS UF" checkbox/>
          <Input name="percDifUf" label="Perc. Diferimento UF" checkbox/>
          <Input name="valorDifUf" label="Valor Diferimento UF" checkbox/>
          <Input name="tribDevolvidoUf" label="Tributo Devolvido UF" checkbox/>
          <Input name="percRedAliquotaUf" label="Perc. Red. Alíquota UF" checkbox/>
          <Input name="aliquotaEfeIbsUf" label="Alíquota Efetiva IBS UF" checkbox/>
          <Input name="valorIbsUf" label="Valor IBS UF" checkbox/>
          <Input name="aliquotaIbsMun" label="Alíquota IBS Municipal" checkbox/>
          <Input name="percDifMun" label="Perc. Diferimento Municipal" checkbox/>
          <Input name="valorDifMun" label="Valor Diferimento Municipal" checkbox/>
          <Input name="tribDevolvidoMun" label="Tributo Devolvido Municipal" checkbox/>
          <Input name="percRedAliquotaMun" label="Perc. Red. Alíquota Municipal" checkbox/>
          <Input name="aliquotaEfeIbsMun" label="Alíquota Efetiva IBS Municipal" checkbox/>
          <Input name="valorIbsMun" label="Valor IBS Municipal" checkbox/>
          <Input name="valorIbsUfMun" label="Valor do IBS (UF + Mun)" checkbox/>
          <Input name="aliquotaCbs" label="Alíquota CBS" checkbox/>
          <Input name="percDifCbs" label="Perc. Diferimento CBS" checkbox/>
          <Input name="valorDifCbs" label="Valor Diferimento CBS" checkbox/>
          <Input name="valorCbsDevolvido" label="Valor CBS Devolvida" checkbox/>
          <Input name="percRedCbs" label="Perc. Redução CBS" checkbox/>
          <Input name="aliquotaEfetivaCbs" label="Alíquota Efetiva CBS" checkbox/>
          <Input name="valorCbs" label="Valor CBS" checkbox/>
          <Input name="cstTribRegular" label="CST Tributação Regular" checkbox/>
          <Input name="codClassTribRegular" label="Cód. Class. Tributária Regular" checkbox/>
          <Input name="aliquotaEfetivaRegUf" label="Alíquota Efetiva Regular UF" checkbox/>
          <Input name="valorTribRegUf" label="Valor Tributo Regular UF" checkbox/>
          <Input name="aliquotaEfetivaRegMun" label="Alíquota Efetiva Regular Município" checkbox/>
          <Input name="valorTribRegMun" label="Valor Tributo Regular Município" checkbox/>
          <Input name="aliquotaEfeRegCbs" label="Alíquota Efetiva Regular CBS" checkbox/>
          <Input name="valorTribRegCbs" label="Valor Tributo Regular CBS" checkbox/>
          <Input name="aliquotaIbsCompGovUf" label="Alíquota IBS Compras Gov. UF" checkbox/>
          <Input name="valorTribIbsCompGovUf" label="Valor Tributo IBS Compras Gov. UF" checkbox/>
          <Input name="aliqIbsCompGovMun" label="Alíquota IBS Compras Gov. Município" checkbox/>
          <Input name="valorTribCompGovMun" label="Valor Tributo Compras Gov. Município" checkbox/>
          <Input name="aliquotaIbsCbsCompGov" label="Alíquota IBS do CBS Compras Gov." checkbox/>
          <Input name="valorTribComprasGovCbs" label="Valor Tributo Compras Gov. CBS" checkbox/>
          <Input name="valorIbsEstorno" label="Valor IBS para Estorno" checkbox/>
          <Input name="valorCbsEstorno" label="Valor CBS para Estorno" checkbox/>
        </div>
      </FormSection>
  );
}
